<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "LeadTimendex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
